import React, { useRef, useState, useEffect } from 'react';
import { Button, Dialog, Icon,Tooltip,Position} from '@blueprintjs/core';
import { FilledButton} from '../../components/buttons-20250224T111359Z-001/buttons';
import ConfirmationDialog from '../../views/ConfirmationDialog';
import Delete from '../../assets/Delete.svg';
import ToastStore from '../../stores/ToastStore';
import axios from 'axios';
import Cookies from 'js-cookie';


const getApiUrl = (endpoint) => {
  const apiEnv = Cookies.get('apiEnv');
  const base = apiEnv ? apiEnv.replace(/\/+$/, '') : '';
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${base}${cleanEndpoint}`;
};

const FeedbackRaterTypeDialog = ({ isOpen, onClose, options = [], onChange}) => {

  const [title, setTitle] = useState('');
  const [editingKey, setEditingKey] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const inputRef = useRef(null);


  /* Focus input whenever dialog opens */
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 50);
    }
  }, [isOpen]);


  /* Reset form */
  const resetForm = () => {
    setTitle('');
    setEditingKey(null);
    setIsSaving(false);
  };

  /* Close dialog */
  const close = () => {
    resetForm();
    setDeleting(null);
    onClose();
  };

  /* Save / Update rater type */
  const save = (e) => {
    e.preventDefault();
    const cleanTitle = title.trim();
    if (isSaving) return;
    if (!cleanTitle) {
      ToastStore.showToast( 'Please enter a rater type', 'warning');
      return;
    }

    /* Prevent duplicate names */
    const duplicate = options.some(
      item =>
        item.id !== editingKey &&
        item.title?.toLowerCase() === cleanTitle.toLowerCase()
    );

    if (duplicate) {
      ToastStore.showToast('A rater type with this name already exists', 'warning');
      return;
    }

    (async () => {

      try {
         setIsSaving(true);
      

          // const existing = options.find( item => item.value === editingKey) || {};
          // const id = existing.id || editingKey;
          // const url = getApiUrl( `/rater/${id}`);
          // await axios.put(url, { title: cleanTitle });
          // ToastStore.showToast('Rater type updated successfully','success');
          if (editingKey) {
            const url = getApiUrl(`/rater/${editingKey}`);
          
            await axios.put(url, {
              title: cleanTitle
            });
          
            ToastStore.showToast(
              'Rater type updated successfully',
              'success'
            );
          }
        
        else {
          const url = getApiUrl( '/rater');
          await axios.post(url, { title: cleanTitle});
          ToastStore.showToast( 'Rater type created successfully', 'success' );
        }
        resetForm();
        inputRef.current?.focus();
        if (onChange) {
          onChange();
        }
      } catch (err) {
        const msg = err?.response?.data?.error ||  err?.message ||
          'Failed to save rater type';
        ToastStore.showToast(Array.isArray(msg) ? msg.join(', ') : msg, 'danger' );
      } finally {
        setIsSaving(false);
      }
    })();
  };


  /* Delete rater type  */
  const remove = () => {
    if (!deleting) return;
  
    (async () => {
      try {
        const id = deleting.id; 
        if (!id) {
          ToastStore.showToast('Rater type ID is missing', 'danger');
          return;
        }
        const url = getApiUrl(`/rater/${id}`); 
        await axios.delete(url); 
        if (editingKey === id) {
          resetForm();
        } 
        setDeleting(null); 
        ToastStore.showToast('Rater type deleted successfully', 'success' ); 
        if (onChange) {
          onChange();
        }
      } catch (err) {
        const msg = err?.response?.data?.error || err?.message || 'Failed to delete rater type';
        ToastStore.showToast(Array.isArray(msg) ? msg.join(', ') : msg, 'danger');
      }
    })();
  };

  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={close}
        title="Manage Rater Category"
        className="feedback-competency-dialog"
        portalContainer={document.body}
        canEscapeKeyClose={!deleting}
        canOutsideClickClose={!deleting}
      >

        <div className="competency-dialog-body">
          {/* FORM */}
          <form className="competency-form" onSubmit={save} >
            <input
              ref={inputRef}
              id="feedback-rater-type-title"
              className="bp3-input"
              type="text"
              autoFocus
              placeholder="e.g. Direct Report"
              value={title}
              maxLength={120}
              onChange={e => {
                setTitle(e.target.value);
              }}
            />
            <FilledButton
              type="submit"
              text={editingKey ? 'Save' : 'Add'}
              disabled={isSaving}
            />
          </form>
          {/* LIST HEADER */}
          <div className="competency-list-heading">
            <h3> All rater types </h3>
            <span>  {options.length} </span>

          </div>
          {/* LIST */}
          <div className="competency-list">
            {options.length === 0 ? (
              <div className="competency-empty">
                <Icon icon="people" iconSize={26} />
                <h4>  No rater types yet  </h4>
                <p> Add your first evaluator type
                  using the title field above.
                </p>
              </div>
            ) : (
              <ul>
                {options.map(item => (
                  <li
                    key={item.id}
                    
                    className={
                      editingKey === item.id
                        ? 'is-editing'
                        : ''
                    }
                  >
                    <span className="competency-row-icon">
                      <Icon icon="person" iconSize={15}  />
                    </span>
                    <span className="competency-row-title">
                      {item?.title}
                    </span>
                    { item?.is_default ?
                   ( <div className="competency-row-actions">
                      {/* EDIT */}
                      <Tooltip
                        portalContainer={document.body}
                        content="Edit rater type"
                        position={Position.TOP}
                        hoverCloseDelay={50}
                        openOnTargetFocus={false}
                      >

                        <Button
                          icon={
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                              <path
                                d="M7.63704 21.2615H2.51904L2.69554 16.1885L16.1595 3.1285C16.4168 2.87888 16.761 2.73903 17.1194 2.73847C17.4779 2.73791 17.8225 2.87669 18.0805 3.1255L21.059 5.9975C21.1916 6.12538 21.2973 6.27848 21.3698 6.44778C21.4424 6.6172 21.4803 6.79918 21.4815 6.98337C21.4827 7.16756 21.447 7.35012 21.3766 7.52033C21.3062 7.69053 21.2025 7.84495 21.0715 7.9745L7.63704 21.2615ZM3.47254 20.3385H7.25854L20.4235 7.3195C20.4672 7.27634 20.5018 7.22488 20.5253 7.16815C20.5488 7.11142 20.5607 7.05056 20.5603 6.98916C20.56 6.92776 20.5473 6.86705 20.5231 6.81061C20.499 6.75416 20.4637 6.70313 20.4195 6.6605L17.441 3.7885C17.3552 3.70538 17.2403 3.65891 17.1208 3.65891C17.0013 3.65891 16.8864 3.70538 16.8005 3.7885L3.60054 16.5885L3.47254 20.3385Z"
                                fill="#1870d5"
                              />
                              <path
                                d="M18.8589 9.5245L14.4719 5.21L15.2029 4.491L19.5899 8.8055L18.8589 9.5245Z"
                                fill="#1870d5"
                              />
                            </svg>
                          }
                          minimal
                          onClick={() => {
                            setEditingKey(item.id);
                            setTitle(item.title);
                          }}
                          className="edit-section-btn no-hover-btn"
                        />
                      </Tooltip>

                      {/* DELETE */}
                      <Tooltip
                        portalContainer={document.body}
                        content="Delete rater type"
                        position={Position.TOP}
                        hoverCloseDelay={50}
                        openOnTargetFocus={false}
                      >
                        <Button
                          icon={<img src={Delete} alt="Delete Icon" style={{ width: 18,  height: 18 }} /> }
                          minimal={true}
                          onClick={e => {
                            e.stopPropagation();
                            setDeleting(item);
                          }}
                        />
                      </Tooltip>
                    </div>) : ""
                }
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </Dialog>

      {/* DELETE CONFIRMATION */}
      <ConfirmationDialog
        isOpen={!!deleting}
        onClose={() => setDeleting(null)}
        onConfirm={remove}
        title="Delete Rater Type"
        message="Are you sure you want to delete "
        itemName={deleting?.title || ''}
        confirmText="Delete"
        confirmIntent="danger"
      />
    </>
  );
};

export default FeedbackRaterTypeDialog;